import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select/lib/Select';
import isFunction from 'lodash/isFunction';
import cx from 'classnames';
import styles from './OMGenericSelect.scss';

class OMGenericSelect extends Component {
  constructor(...props) {
    super(...props);
    this.state = {
      value: ''
    };
  }

  handleInput(value) {
    this.setState({
      value
    });
  }

  handleChange(evt) {
    this.setState({ value: '' });
    this.props.onChange(evt);
  }

  render() {
    return (
      <Select
        className={cx(this.props.className, { [styles.hideResults]: this.state.value })}
        placeholder={this.props.placeholder}
        options={this.props.options}
        instanceId="home"
        onChange={(evt) => {
          this.props.onChange(evt); // looks like this func is not working when passed from props
          if (this.props.onSelectedValue && isFunction(this.props.onSelectedValue)) {
            this.props.onSelectedValue(evt);
          }
        }}
        value={this.props.value}
        onBlur={() => (this.state.value ? this.props.onChange(this.state.value) : null)}
        onInputChange={val => this.handleInput(val)}
        searchable={false}
        clearable={false}
      />
    );
  }
}

OMGenericSelect.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
  onSelectedValue: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.bool
  ]),
  className: PropTypes.string
};

export default OMGenericSelect;
